export const getAppointmentStatus = id => {
  switch (id) {
    case 1:
      return 'Pendente';
    case 2:
      return 'Aprovado';
    case 3:
      return 'Recusado';
    default:
      return '';
  }
};

export const initialValues = data => {
  if (Object.keys(data).length <= 0) return {};

  const { horas_extras: horasExtras } = data;

  const { nome_projeto: nomeProjeto, categoria, subcategoria, observacao } =
    horasExtras[0] || [];

  return {
    extraHourProject: nomeProjeto,
    extraHourCategory: categoria,
    extraHourSubtopic: subcategoria,
    extraHourNote: observacao,
  };
};
